import React from 'react';

import { ManagementTable } from './ManagementTable';

export function AdminManagement() {
  return (
    <div className="root">
      <ManagementTable />
    </div>
  );
}
